import {throwAlertMessage} from "./utils";

export function getSkiTicketBaseConfig() {
    const _config = window._config || {};

    let baseConfig = _config.skiTicketConfigUrls;

    if (!baseConfig) {
        throwAlertMessage('warning', 'MISSING CONFIG', 'Missing config "_config.skiTicketConfigUrls". Value of "_config.skiTicketConfigUrls" was not set in _config', true);
    }

    return baseConfig;
}

export function getActivityBaseConfig() {
    const _config = window._config || {};

    let activityBaseConfig = _config.activityConfigUrls;

    if (!activityBaseConfig) {
        throwAlertMessage('warning', 'MISSING CONFIG', 'Missing config "_config.activityConfigUrls". Value of "_config.activityConfigUrls" was not set in _config', true);
    }

    return activityBaseConfig;
}

export function getPriceCalculatorBaseConfig() {
    const _config = window._config || {};

    let priceCalculatorBaseConfig = _config.priceCalculatorConfigUrls;

    if (!priceCalculatorBaseConfig) {
        throwAlertMessage('warning', 'MISSING CONFIG', 'Missing config "_config.activityConfigUrls". Value of "_config.activityConfigUrls" was not set in _config', true);
    }

    return priceCalculatorBaseConfig;
}

export function getB2BSkiTicketBaseConfig() {
    const _config = window._config || {};

    let baseConfig = _config.b2bSkiTicketConfigUrls;

    if (!baseConfig) {
        throwAlertMessage('warning', 'MISSING CONFIG', 'Missing config "_config.b2bSkiTicketConfigUrls". Value of "_config.b2bSkiTicketConfigUrls" was not set in _config', true);
    }

    return baseConfig;
}

export function getB2BActivityBaseConfig() {
    const _config = window._config || {};

    let baseConfig = _config.b2bActivityConfigUrls;

    if (!baseConfig) {
        throwAlertMessage('warning', 'MISSING CONFIG', 'Missing config "_config.b2bActivityConfigUrls". Value of "_config.b2bActivityConfigUrls" was not set in _config', true);
    }

    return baseConfig;
}

export function getCrossSellingDataUrl() {
    const _config = window._config || {};

    let baseConfig = _config.crossSellingDataUrl;

    if (!baseConfig) {
        throwAlertMessage('warning', 'MISSING CONFIG', 'Missing config "_config.b2bActivityConfigUrls". Value of "_config.b2bActivityConfigUrls" was not set in _config', true);
    }

    return baseConfig;
}


export function getConfig(configName) {
    const _config = window._config || {};

    let baseConfig = _config[configName];

    if (!baseConfig) {
        throwAlertMessage('warning', 'MISSING CONFIG', `Missing config ${configName}. Value of ${configName} was not set in _config`, true);
    }

    return baseConfig;
}

export function getLanguageConfig() {
    const _config = window._config || {};

    let baseConfig = _config.localeRegion;

    if (!baseConfig) {
        throwAlertMessage('warning', 'MISSING CONFIG', 'Missing config "_config.localeRegion". Value of "_config.localeRegion" was not set in _config', true);
    }

    return baseConfig;
}

export function getCurrencyRates() {
    const _config = window._config || {};

    let baseConfig = _config.currencyRates;

    if (!baseConfig) {
        throwAlertMessage('warning', 'MISSING CONFIG', 'Missing config "_config.currencyRates". Value of "_config.currencyRates" was not set in _config', true);
    }

    return baseConfig;
}